import { Injectable } from '@angular/core';
import { Api } from '../../core/classes/api';
import { Observable } from 'rxjs';
import {
  GetSubscriptionClientsResponse,
  GetSubscriptionsResponse,
  GetMyPlanResponse,
  GetSubscriptionAlertsResponse,
  AssignSubscriptionRequest,
  AssignSubscriptionResponse,
  UpdateSubscriptionRequest,
  UpdateSubscriptionResponse,
  GetSubscriptionUsersResponse,
} from '../../core/models/subscription.model';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService extends Api {
  constructor() {
    super();
  }

  /** Admin: listar todos los clientes disponibles para asignar suscripción */
  getClientsForSubscriptionAssignment(): Observable<GetSubscriptionClientsResponse> {
    return this.http.get<GetSubscriptionClientsResponse>(`${this.url}/subscriptions/clients`);
  }

  /** Admin: listar todas las suscripciones */
  getAll(): Observable<GetSubscriptionsResponse> {
    return this.http.get<GetSubscriptionsResponse>(`${this.url}/subscriptions`);
  }

  /** Cliente autenticado: obtener su suscripción activa */
  getMySubscription(): Observable<GetMyPlanResponse> {
    return this.http.get<GetMyPlanResponse>(`${this.url}/subscriptions/my-plan`);
  }

  /** Cliente autenticado: obtener alertas de consumo */
  getAlerts(): Observable<GetSubscriptionAlertsResponse> {
    return this.http.get<GetSubscriptionAlertsResponse>(`${this.url}/subscriptions/alerts`);
  }

  /** Admin: asignar un plan a un cliente */
  assignSubscription(clientId: number, payload: AssignSubscriptionRequest): Observable<AssignSubscriptionResponse> {
    return this.http.post<AssignSubscriptionResponse>(`${this.url}/subscriptions/${clientId}`, payload);
  }

  /** Admin: actualizar una suscripción existente */
  updateSubscription(subscriptionId: number, payload: UpdateSubscriptionRequest): Observable<UpdateSubscriptionResponse> {
    return this.http.put<UpdateSubscriptionResponse>(`${this.url}/subscriptions/${subscriptionId}`, payload);
  }

  /** Admin: obtener usuarios disponibles para asignar a una suscripción */
  getUsers(): Observable<GetSubscriptionUsersResponse> {
    return this.http.get<GetSubscriptionUsersResponse>(`${this.url}/subscriptions/users`);
  }

  /** Admin: obtener historial de pagos de una suscripción */
  getPayments(subscriptionId: number): Observable<any> {
    return this.http.get<any>(`${this.url}/subscriptions/${subscriptionId}/payments`);
  }

  /** Admin: registrar un nuevo pago para una suscripción */
  registerPayment(subscriptionId: number, payload: any): Observable<any> {
    return this.http.post<any>(`${this.url}/subscriptions/${subscriptionId}/payments`, payload);
  }
}
